import { useTranslation } from 'react-i18next';
import { Navigation, SideBarRoutes } from '../utils/SideBarRoutes';
import { useFeatureFlag } from '../contexts/FeatureFlagContext';
import { useGetUserinfo } from './queries/useGetUserinfo.ts';
import { useUsesSafetyReps } from './queries/hms/useHmsSettingsQuery';
import { useUserOnboardingQuery } from './queries/onboarding/useUserOnboarding';
import { groupForRole } from '../pages/GettingStarted/gettingStartedView';

/**
 * Navigasjonen for innlogget bruker, filtrert på roller og aktiverte funksjoner.
 * Brukes av både sidemenyen og mobilmenyen.
 */
export const useSidebarRoutes = (): Navigation => {
  const { t } = useTranslation();
  const { features } = useFeatureFlag();
  const { data: userInfo } = useGetUserinfo();
  const usesSafetyReps = useUsesSafetyReps(features.includes('WORK_ENVIRONMENT'));
  // The role the user chose decides which part of the menu comes first
  const { data: onboarding } = useUserOnboardingQuery(Boolean(userInfo));

  return SideBarRoutes.getNavigation(
    userInfo?.userRoles,
    features,
    t,
    usesSafetyReps,
    groupForRole(onboarding?.role ?? null),
    // The team leader's part only for those who lead a team, or the administrator
    userInfo?.leadsTeam ?? false,
  );
};
